module.exports = {"411528001":"谯楼街道","411528002":"龙湖街道","411528003":"淮河街道","411528101":"包信镇","411528102":"夏庄镇","411528103":"东岳镇","411528104":"项店镇","411528105":"小茴店镇","411528106":"曹黄林镇","411528201":"孙庙乡","411528202":"路口乡","411528203":"彭店乡","411528204":"杨店乡","411528205":"张陶乡","411528206":"白土店乡","411528207":"岗李店乡","411528208":"长陵乡","411528209":"陈棚乡","411528210":"临河乡","411528211":"关店乡","411528214":"八里岔乡","411528400":"濮公山管理区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411528.json
// module id = 1795
// module chunks = 0